import React from 'react';
import Header from '../components/Header';
import Employee from './Employee';


function Layout(){
    return(
        <main>
            <Header/>
            <Employee/>
         </main>
    )

}
export default Layout;